/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Book_PreviewInputs */

const en_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book Preview`)
};

const es_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista Previa del Libro`)
};

const fr_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu du Livre`)
};

const de_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchvorschau`)
};

const ja_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本のプレビュー`)
};

const zh_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图书预览`)
};

const ar_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معاينة الكتاب`)
};

const id_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pratinjau Buku`)
};

const it_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima Libro`)
};

const ru_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предпросмотр Книги`)
};

const pt_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização do Livro`)
};

const ko_book_preview = /** @type {(inputs: Book_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`책 미리보기`)
};

/**
* | output |
* | --- |
* | "Book Preview" |
*
* @param {Book_PreviewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const book_preview = /** @type {((inputs?: Book_PreviewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Book_PreviewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_book_preview(inputs)
	if (locale === "es") return es_book_preview(inputs)
	if (locale === "fr") return fr_book_preview(inputs)
	if (locale === "de") return de_book_preview(inputs)
	if (locale === "ja") return ja_book_preview(inputs)
	if (locale === "zh") return zh_book_preview(inputs)
	if (locale === "ar") return ar_book_preview(inputs)
	if (locale === "id") return id_book_preview(inputs)
	if (locale === "it") return it_book_preview(inputs)
	if (locale === "ru") return ru_book_preview(inputs)
	if (locale === "pt") return pt_book_preview(inputs)
	return ko_book_preview(inputs)
});